module.exports = __webpack_public_path__ + "static/img/Schneider-NYC-0142.03d4164.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thumbnails/Schneider-NYC-0142.jpg
// module id = +Nka
// module chunks = 0